const content: { [key: string]: string } = {
  tabTitle: "Maintenance",
  sorryMaintenance: "Sorry, this site is down for maintenance.",
  backUpSoon: "We will be back up and running soon.",
  tryAgainLater: "Please try again later",
};

export default content;
